import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoggingModule } from '@cm/core/logging';

/**
 *
 * @deprecated Use @cm/core/logging LoggingModule
 */
@NgModule({
	imports: [CommonModule, LoggingModule],
})
export class AtsLoggerModule {}
